const rollBackToBatch = (items) =>
  items.reduce(
    (acc, { elementId, target, value }) => ({
      ...acc,
      [elementId]: {
        ...acc[elementId],
        [target]: value,
      },
    }),
    {}
  );

const unrollBatch = (batch) =>
  Object.entries(batch).flatMap(([elementId, targets]) =>
    Object.entries(targets).map(([target, value]) => ({
      elementId,
      target,
      value,
    }))
  );

const defaultFilterCallback = () => true;
const defaultComputeValueCallback = ({ value }) => value;

const modifyBatchChanges = ({
  batch,
  onFilterCallback = defaultFilterCallback,
  onComputeValueCallback = defaultComputeValueCallback,
}) => {
  const unrolledBatch = unrollBatch(batch);
  const modifiedBatch = unrolledBatch.filter(onFilterCallback).map((item) => ({
    ...item,
    value: onComputeValueCallback(item),
  }));

  return rollBackToBatch(modifiedBatch);
};

export default modifyBatchChanges;
